import { Box, Skeleton, Stack } from '@mui/material'
import React from 'react'

const DesktopFiltersShimmer: React.FC = () => (
    <Box
        sx={{
            bgcolor: 'transparent',
            borderRadius: 1.5,
            border: 1,
            borderColor: 'grey.200',
            overflow: 'hidden',
            boxShadow: 'none',
            p: 2,
            minWidth: 240
        }}
    >
        {/* Filter Header Shimmer */}
        <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />

        {/* Stops Filter Shimmer */}
        <Box sx={{ borderTop: 1, borderBottom: 1, borderColor: 'grey.200', py: 2 }}>
            <Skeleton variant="text" width={40} height={20} sx={{ mb: 1 }} />
            <Stack spacing={1} sx={{ mb: 2 }}>
                <Box display="flex" gap={1}>
                    {[...Array(3)].map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width={75} height={50} sx={{ borderRadius: 1 }} />
                    ))}
                </Box>
            </Stack>
        </Box>
        {/* Flight Timings Filter Shimmer */}
        <Box py={1} sx={{ borderBottom: 1, borderColor: 'grey.200' }}>
            <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
            <Box display="flex" flexWrap="wrap" gap={1} py={1}>
                {[...Array(5)].map((_, i) => (
                    <Skeleton key={i} variant="rectangular" width={110} height={40} sx={{ borderRadius: 1 }} />
                ))}
            </Box>
        </Box>
        {/* Airlines Filter Shimmer */}
        <Box sx={{ py: 2 }}>
            <Skeleton variant="text" width={50} height={20} sx={{ mb: 2 }} />
            <Stack spacing={1}>
                {[...Array(10)].map((_, i) => (
                    <Box key={i} display="flex" alignItems="center" gap={1} flex={1}>
                        <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: 0.5 }} />
                        <Box display="flex" gap={1} mx={1}>
                            <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 0.5 }} />
                            <Skeleton variant="text" width={50} height={20} />
                        </Box>
                        <Box display={'flex'} alignItems={'flex-end'} sx={{ ml: 'auto' }}>
                            <Skeleton variant="text" width={40} height={30} sx={{ borderRadius: 1 }} />
                        </Box>
                    </Box>
                ))}
            </Stack>
        </Box>
    </Box>
)

export default DesktopFiltersShimmer
